import { Service } from '@roc/feature-app-core';

const url = {
  GET_BORROWER_LOAN: '/api/v1/loan/unified/borrowerLoans/getBorrowerLoanById',
};

export class BorrowerLoanDetailsService extends Service {
  getBorrowerLoan(loanId, source?: string) {
    return this.get(url.GET_BORROWER_LOAN, { loanId, source });
  }
}
